import { Component, Input, OnInit } from '@angular/core';
import { NbMenuService } from '@nebular/theme';
import { MenuGroup } from '../../dynamic-input-model';

@Component({
  selector: 'ngx-product-input',
  templateUrl: './product-input.component.html',
  styleUrls: ['./product-input.component.scss']
})
export class ProductInputComponent implements OnInit {
  @Input() data:any;
  defaultMenuTag:string; 
  topLevelMenuTag = "editProductPageRouteMenu";
  activeInputMenuItem:string;
  defaultInputMenuItem:string;
  menuItemTitle:string;
  menuGroups:any;
  
  constructor(private menuService:NbMenuService) { }

  ngOnInit(): void {
    console.log(this.data);
    this.menuGroups = this.data;
    let topLevelMenu:MenuGroup = this.menuGroups["topLevelMenu"];

    if(topLevelMenu != undefined){
      this.defaultMenuTag = topLevelMenu.menuTag;
      this.defaultInputMenuItem = topLevelMenu.menuItems[0].title;
      this.activeInputMenuItem = this.defaultInputMenuItem;
    }
    this.menuService.onItemClick().subscribe(menuBag =>{
      console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        console.log({selectedItem:selectedItem});
        this.activeInputMenuItem = selectedItem.title;
      }
    })
  }

  tabChanged(e){

  }

}
